import React, { useEffect } from 'react';
import {  Route, Routes, BrowserRouter } from 'react-router-dom';
import './App.css';
import './responsive.css';
import LoginComponent from './components/LoginComponent/LoginComponent';

import Page2 from './components/Page2';
import Notfound from './components/NotfoundComponent/Notfound';
import ProtectedRoute from './Protectedroutes/ProtectedRoutes';
import SignupComponent from './components/SignupComponent/SignupComponent';

import Dashboard from './components/Dashboardcomponent/Dashboard';
import ProfileComponent from './components/ProfileComponent/ProfileComponent';
import SettingsComponent from './components/SettingsComponent/SettingsComponent';

import Page1 from './components/Page1';
import AccountComponent from './components/AccountComponent/AccountComponent';
import ForgotPassword from './components/ForgotPasswordComponent/ForgotPassword';
import ResetPassword from './components/ResetPasswordComponent/ResetPasswordComponent';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoginRoute from './Protectedroutes/LoginRoute';
import ClCalculationComponent from './components/Cl_CalculationComponent/ClCalculationComponent';
import { persistor } from './redux/store';
import { PersistGate } from 'redux-persist/lib/integration/react';
import Account2 from './components/Account2Component.js/Account2';
import Account1 from './components/MoneyManagementComponent/Account1';
import MoneyManagementComponent from './components/MoneyManagementComponent/MoneyManagementComponent';
import { useDispatch } from 'react-redux';
import { userlogout } from './redux/userSlice';
import ProtectRouteusingvalue from './Protectedroutes/ProtectRouteusingvalue';
import DefaultPasswordComponent from './components/DefaultPasswordComponent/DefaultPasswordComponent';
import AdminDashborad from './AdminComponents/AdminDashborad';
import AdminSettings from './AdminComponents/AdminSettings';

import LoginDefaultPassword from './LoginDefaultPassword/LoginDefaultPassword';


const App = () => {


  return (

    <BrowserRouter>
     <PersistGate loading={null} persistor={persistor}>
    <>
    <ToastContainer 
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Routes>
          {/* Admin routing start*/}
          
          <Route path="/login" element={
            <LoginRoute><LoginComponent /></LoginRoute>
           } />
           <Route path="/check-registration/:emailId/:Urltoken" element={ <LoginRoute>< LoginDefaultPassword /></LoginRoute>} />
          <Route path="/" element={ <LoginRoute><LoginComponent /></LoginRoute>} />
          <Route path="/signup" element={<LoginRoute><SignupComponent /></LoginRoute> } />
          <Route path="/forgotpassword" element={<LoginRoute><ForgotPassword /></LoginRoute>} />
          <Route path="/PasswordRecovary" element={<LoginRoute><ResetPassword /></LoginRoute>} />
          <Route path="/defaultPassword/:email" element={<LoginRoute><DefaultPasswordComponent /></LoginRoute>} />
          <Route
            path="/admin/user"
            element={
              <ProtectedRoute>
                <AdminDashborad/>
               </ProtectedRoute>
            }
          />

<Route
            path="/admin/settings"
            element={
              <ProtectedRoute>
                <AdminSettings/>
               </ProtectedRoute>
            }
          />
{/* <Route
            path="/admin/profile"
            element={
              <ProtectedRoute>
                <ProfileComponent />
              </ProtectedRoute>
            }
          /> */}
          {/* <Route path="/page1" element={<Page1 />} /> */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard/>
              </ProtectedRoute>
            }
          />
       
          <Route
            path="/profile"
            element={
              <ProtectRouteusingvalue>
                <ProfileComponent />
              </ProtectRouteusingvalue>
            }
          />

<Route path="*" element={<Notfound />} />
          </Routes>

          </>
          </PersistGate>
          </BrowserRouter>
          
  );
};

export default App;
